import { getUserFirstName } from '../../platform/telegram'
import { useT } from '../../platform/i18n/useT'
import './screens.css'

/**
 * Вводный экран, показывается один раз.
 *
 * Отдельного замера нет намеренно: первая обычная тренировка и есть
 * базовый замер. Экран объясняет, что счёт сначала будет приблизительным
 * и уточнится за несколько заходов - иначе предварительная оценка
 * выглядела бы как настоящая и обесценилась бы при первом же уточнении.
 */
export function Onboarding({ onStart }: { onStart: () => void }) {
  const { t } = useT()
  const name = getUserFirstName()

  return (
    <div className="ob">
      <div className="ob__em">{t('app.name')}</div>
      <h1 className="ob__h">
        {name ? t('onboarding.helloName', { name }) : t('onboarding.hello')}
      </h1>

      <ol className="ob__list">
        <li>
          <b>{t('onboarding.p1.title')}</b>
          <span>{t('onboarding.p1.text')}</span>
        </li>
        <li>
          <b>{t('onboarding.p2.title')}</b>
          <span>{t('onboarding.p2.text')}</span>
        </li>
        <li>
          <b>{t('onboarding.p3.title')}</b>
          <span>{t('onboarding.p3.text')}</span>
        </li>
      </ol>

      <button type="button" className="ob__btn" onClick={onStart}>
        {t('onboarding.start')}
      </button>
    </div>
  )
}
